import React, { useContext } from 'react';

import { GlobalFiltersContext } from '../../GlobalFiltersContext';
import { OneTimeFetch } from './use-cases/OneTimeFetch';

export const EventFilter = ({}) => {
  const {
    loadingGlobal,
    eventVisible,
    eventSearchValue,
    eventLoading,
    eventLoaded,
    eventError,
    eventData,
    eventRI,
    setEventVisible,
    setEventSearchValue,
    setEventLoading,
    setEventLoaded,
    setEventError,
    setEventData,
    setEventRI,
    updateData,
    setPage
  } = useContext(GlobalFiltersContext);

  return (
    <OneTimeFetch
      segment="event"
      placeholder="Eventos"
      loadingGlobal={loadingGlobal}
      visible={eventVisible}
      searchValue={eventSearchValue}
      loading={eventLoading}
      loaded={eventLoaded}
      error={eventError}
      data={eventData}
      ri={eventRI}
      setVisible={setEventVisible}
      setSearchValue={setEventSearchValue}
      setLoading={setEventLoading}
      setLoaded={setEventLoaded}
      setError={setEventError}
      setData={setEventData}
      setRI={setEventRI}
      updateData={updateData}
      setPage={setPage}
    />
  );
};
